<template>
  <Component
    :is="`h${attrs.level}`"
    :style="{ ...attrs }"
    :class="{ 'text-container': attrs.level > 1 }"
  >
    <EditorParagraphBlockContent
      v-for="(item, idx) in content"
      :key="idx"
      :marks="item.marks?.slice(1)"
      :mark="item.marks?.[0]"
      :text="item.text"
      :type="item.type"
      :attrs="item.attrs"
      :text-info="item.attrs?.text"
    />
  </Component>
</template>

<script setup>
defineProps({
  attrs: {
    type: Object,
    default: () => ({}),
  },
  content: {
    type: Array,
    default: () => [],
  },
});
</script>
